import {take, put, call} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as samsActionTypes from '../samsActionTypes';
import sendAttachmentsWithAssignmentFlow from '../../service-cases/sagas/sendAttachmentsWithAssignmentFlow';

/**
 * Update SAMS cost coverage flow
 */
const updateSAMSCostCoverageFlow = function* updateSAMSCostCoverageFlow() {
    while (true) {
        const {payload} = yield take(samsActionTypes.SUBMIT_SAMS_COST_COVERAGE_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData} = payload;
        const {serviceCaseType, serviceCaseId, serviceCaseData, attachmentsToSendWithAssignment} = payload;

        yield call(sendAttachmentsWithAssignmentFlow, {
            caller: samsActionTypes.SUBMIT_SAMS_COST_COVERAGE_FORM,
            attachmentsToSendWithAssignment,
            serviceCaseId,
        });

        yield* updateServiceCase({
            caller: samsActionTypes.SUBMIT_SAMS_COST_COVERAGE_FORM,
            caseType: serviceCaseType,
            serviceCaseId,
            serviceCaseData,
        });

        yield* updateServiceAssignment({
            caller: samsActionTypes.SUBMIT_SAMS_COST_COVERAGE_FORM,
            assignmentType: efServiceAssignmentTypes.MEDICINE_SHIPMENT,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: samsActionTypes.SUBMIT_SAMS_COST_COVERAGE_FORM},
        });
    }
};

export default updateSAMSCostCoverageFlow;
